<template>
  <div class="custom_dark_blue_bg">
    <div class="outer-container">
      <div class="ucontainer">
        <h2 class="heading_fonts text-center ">
          Number of people trained in top 3 category
        </h2>
        <div class="grid">
          <div class="" style="border-left:36px solid #2465F3">
            <h3 class="custom_white manrope pl-4">
              Digital/Content
              <br />
              Marketing
            </h3>
            <h2 class="number">
              150+
            </h2>
          </div>
          <div class="" style="border-left:36px solid #2465F3">
            <h3 class="custom_white manrope  pl-4">
              Design
              <br />
              /UIUX
            </h3>
            <h2 class="number">
              340+
            </h2>
          </div>
          <div class="" style="border-left:36px solid #2465F3">
            <h3 class="custom_white manrope  pl-4">
              Data science/
              <br />
              Machine Learning/Analytics
            </h3>
            <h2 class="number">
              700+
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.heading_fonts {
  font: 800 2.1rem/2.3rem 'Manrope';
  color: white;
  padding-top: 40px;
  padding-bottom: 75px;
}
.number {
  color: #ffdd00;
  font: 700 4.5rem/4rem 'Manrope';
  padding-left: 20px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}
.outer-container {
  padding: 50px 0;
}
</style>
